export enum ContactRequestType {
  CONTACT = 'CONTACT',
  SUPPORT = 'SUPPORT',
  ENTERPRISE = 'ENTERPRISE',
  INVOICE = 'INVOICE',
}
